import { Frown, RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "~/atoms/button";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "~/atoms/empty";

interface Props {
  title?: string;
  message?: string;
  className?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

const ErrorState = ({
  title,
  message,
  className,
  onRetry,
  retryLabel,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Empty className={className}>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Frown />
        </EmptyMedia>
        <EmptyTitle>
          {title ?? t(($) => $.commons.somethingWentWrong)}
        </EmptyTitle>
        <EmptyDescription>
          {message ?? t(($) => $.commons.somethingWentWrongDesc)}
        </EmptyDescription>
      </EmptyHeader>
      {onRetry && (
        <Button onClick={onRetry} variant="outline" size="sm">
          <RotateCcw className="mr-2 h-4 w-4" />
          {retryLabel ?? t(($) => $.commons.buttons.retry)}
        </Button>
      )}
    </Empty>
  );
};

export default ErrorState;
